import { Charge } from '@app/domain/Charge'
import { Business } from '@app/domain/Business'
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { DiaryPreferencesService } from '../../../bookings/services/diary-preferences.service'
import { DurationUnit } from '../../pipes/duration.pipe'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Venue } from '@app/domain/Venue'

@Component({
    selector: 'app-create-charge',
    templateUrl: './create-charge.component.html',
})
export class CreateChargeComponent implements OnInit, OnDestroy {

    @Input() chargeType!: 'cancellationCharge' | 'depositCharge'
    @Input() business!: Business
    @Input() venue!: Venue
    @Input() partySize!: number
    @Input() charge!: Charge | null
    @Input() expiryMinutes!: number | null
    @Input() paidInPerson!: boolean
    @Input() isImmediatelyPaid!: boolean
    @Input() dateTime!: Date
    @Output() chargeCreated = new EventEmitter<{ charge: Charge, expiryMinutes: number | null, paidInPerson: boolean, isImmediatelyPaid: boolean }>()
    canSendLinks = false
    previousExpiryDate: Date | null = null
    expiryDate: Date | null = null

    private onDestroy$ = new EventEmitter<void>()

    constructor(
        protected diaryPreferencesService: DiaryPreferencesService,
        private modal: NgbActiveModal
    ) { }

    ngOnInit() {
        this.canSendLinks = this.business.paymentsAccountForCapability(
            this.chargeType === 'depositCharge' ? 'DepositPayments' : 'CancellationChargePayments'
        ) !== null
        if (this.chargeType === 'depositCharge' && !this.canSendLinks) {
            this.paidInPerson = true
        }
        if (this.charge === null) {
            const defaultCancellationCharge = this.venue.cancellationChargeForPartySize(
                null,
                null,
                this.partySize,
                this.dateTime
            )
            const defaultDepositCharge = this.venue.depositChargeForPartySize(
                null,
                null,
                this.partySize,
                this.dateTime
            )
            this.charge = this.chargeType === 'cancellationCharge' ? defaultCancellationCharge : defaultDepositCharge
        }
        if (this.expiryMinutes !== null) {
            this.previousExpiryDate = new Date()
            this.previousExpiryDate.setTime(this.previousExpiryDate.getTime() + this.expiryMinutes * 60 * 1000)
        }
        if (this.expiryMinutes === null) {
            this.expiryMinutes = this.venue.diaryPreferences.pendingPaymentExpiryMinutes
        }
        this.expiryMinutesChanged(this.expiryMinutes)
    }

    ngOnDestroy() {
        this.onDestroy$.next()
        this.onDestroy$.complete()
    }

    dismiss() {
        this.modal.dismiss()
    }

    save() {
        if (this.charge === null) {
            return
        }
        const expiryMinutes = this.paidInPerson ? null : this.expiryMinutes
        this.chargeCreated.emit({ charge: this.charge, expiryMinutes, paidInPerson: this.paidInPerson, isImmediatelyPaid: this.isImmediatelyPaid })
        this.modal.close()
    }

    expiryMinutesChanged(expiryMinutes: number | null) {
        this.expiryMinutes = expiryMinutes
        if (this.expiryMinutes === -1) {
            this.expiryDate = this.previousExpiryDate !== null ? new Date(this.previousExpiryDate) : null
        } else if (this.expiryMinutes !== null) {
            this.expiryDate = new Date()
            this.expiryDate.setTime(this.expiryDate.getTime() + this.expiryMinutes * 60 * 1000)
        } else {
            this.expiryDate = null
        }
    }

    get showExpiryDate(): boolean {
        return !this.paidInPerson && this.expiryDate !== null
    }

    protected readonly DurationUnit = DurationUnit
}
